/**
 * Модель согласия на использование cookies
 */
export interface CookieConsent {
  /** Необходимые cookies (всегда true, не могут быть отключены) */
  necessary: boolean
  /** Аналитические cookies (Google Analytics, Yandex Metrica и т.д.) */
  analytics: boolean
  /** Маркетинговые cookies (рекламные пиксели, ретаргетинг) */
  marketing: boolean
  /** Персонализационные cookies (настройки UI, предпочтения) */
  preferences: boolean
  /** Временная метка согласия */
  timestamp: string
}

/**
 * Создать объект с согласием на все категории
 */
export function createAcceptAllConsent(): CookieConsent {
  return {
    necessary: true,
    analytics: true,
    marketing: true,
    preferences: true,
    timestamp: new Date().toISOString(),
  }
}

/**
 * Создать объект только с необходимыми cookies
 */
export function createNecessaryOnlyConsent(): CookieConsent {
  return {
    necessary: true,
    analytics: false,
    marketing: false,
    preferences: false,
    timestamp: new Date().toISOString(),
  }
}
